export enum MultiselectMode {
	SINGLE = 'single',
	TAGS = 'tags'
}